(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-section"]) return;
  try {
    
  // Optional: Add loader
  const iframe = document.querySelector('.iframe-container');
  const loader = document.createElement('div');
  
  loader.style.cssText = `
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10000;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 2s linear infinite;
  `;
  
  document.body.appendChild(loader);
  
  iframe.addEventListener('load', () => {
    loader.remove();
  });

  } catch(e) { console.error(e); }
})();
})();
